var map = {
	"./10-gm-achieved.svg": 123,
	"./10-gm-achieved_old.svg": 368,
	"./10-gm-unachieved_old.svg": 369,
	"./10000-gift-voucher.svg": 211,
	"./10gm-gold-coin.svg": 212,
	"./10k-Gift-Voucher.svg": 370,
	"./10k-achieved.svg": 127,
	"./10k-unachieved.svg": 126,
	"./10l-act.svg": 106,
	"./10l-inact.svg": 173,
	"./1l-act.svg": 177,
	"./1l-inact.svg": 171,
	"./1st.svg": 166,
	"./25l-act.svg": 179,
	"./25l-inact.svg": 174,
	"./2nd.svg": 167,
	"./3000-gift-voucher.svg": 213,
	"./3k-achieved.svg": 129,
	"./3k-unachieved.svg": 128,
	"./3l-act.svg": 178,
	"./3l-inact.svg": 172,
	"./3rd.svg": 168,
	"./5-gm-achieved.svg": 125,
	"./5-gm-achieved_old.svg": 371,
	"./5-gm-unachieved.svg": 124,
	"./5-gm-unachieved_old.svg": 372,
	"./5gm-gold-coin.svg": 214,
	"./5l-act.svg": 373,
	"./5l-inact.svg": 374,
	"./BKB-Elements/Congratulations text.svg": 375,
	"./BKB-Elements/Group_12090@2x.svg": 376,
	"./BKB-Elements/Individual rank card.svg": 377,
	"./BKB-Elements/Milestone 10L.svg": 80,
	"./BKB-Elements/Milestone 1L.svg": 65,
	"./BKB-Elements/Milestone 25L.svg": 67,
	"./BKB-Elements/Milestone 5L.svg": 66,
	"./BKB-Elements/Rank table card.svg": 378,
	"./BKB-Elements/Rank_top_nav_bar_bg1.svg": 379,
	"./BKB-Elements/Target Bar.svg": 380,
	"./BKB-Elements/Total poitns card.svg": 381,
	"./BKB-Elements/You have earned 100% bonus point (final popup).svg": 382,
	"./BKB-Elements/bonus icon.svg": 383,
	"./BKB-Elements/milestone-progress-bar.svg": 384,
	"./BKB-Elements/p1.svg": 46,
	"./BKB-Elements/profile-bg.svg": 385,
	"./Ended.svg": 118,
	"./Impact_player_screen/home_screen/score card.svg": 386,
	"./Normal-dist/Rectangle_bg.svg": 387,
	"./Normal-dist/Rectangle_blue_1.svg": 388,
	"./Normal-dist/Rectangle_yellow_1.svg": 389,
	"./RefreshSVG.svg": 390,
	"./ViewDetails.svg": 391,
	"./arrow-right.svg": 105,
	"./asc.svg": 285,
	"./battle-has-begun.svg": 392,
	"./battle-leaderboard.svg": 287,
	"./battle-over.svg": 393,
	"./black-back.svg": 394,
	"./bonus.svg": 284,
	"./bonus_icon.svg": 395,
	"./bor-img.svg": 288,
	"./card-bg-img-2.svg": 396,
	"./card-bg-img.svg": 397,
	"./desc.svg": 121,
	"./jarvis/svg/cancel_close.svg": 220,
	"./live.svg": 116,
	"./pay-point-icon.svg": 95,
	"./pay1-points-fixed-icon.svg": 398,
	"./pay1-points-img.svg": 54,
	"./rank-act.svg": 399,
	"./rank-inact.svg": 400,
	"./refresh-white.svg": 286,
	"./rm-chat-icon.svg": 401,
	"./rm-history.svg": 402,
	"./rm-you-lose.svg": 270,
	"./rm-you-won.svg": 271,
	"./topup.svg": 403,
	"./ws-gc-icon.svg": 404,
	"./ws-vd-icon.svg": 405
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 367;